import { setGlobalAllstatus } from "../store/reducer/globalDropdownSearch..reducer"

export const resetValueGlobalDDS = (dispatch) => {
  dispatch(setGlobalAllstatus(null))
}